import { useNavigate } from "react-router-dom";

import { ButtonSmall } from "@anwb/poncho/components/button";
import Table from "@anwb/poncho/components/table";

import { Product } from "../../types/product";

type ProductTableProps = {
  products: Product[];
};

function ProductTable({ products }: ProductTableProps) {
  const navigate = useNavigate();

  return (
    <Table textAlign="center">
      <Table.Header>
        <Table.Row>
          <Table.HeaderColumn>Name</Table.HeaderColumn>
          <Table.HeaderColumn>Details</Table.HeaderColumn>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {products?.map((product) => {
          return (
            <Table.Row key={product.name}>
              <Table.Column>{product.name}</Table.Column>
              <Table.Column>
                <ButtonSmall color="tertiary" onClick={() => navigate(`/programs/${product.name}`)}>
                  List Programs
                </ButtonSmall>
              </Table.Column>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
}

export default ProductTable;
